export const routes = [
    {
        path: '/package',
        name: 'package',
        component: () => import('@/views/package/Packages.vue'),
        meta: {
            breadcrumb: [
                {
                    text: 'backoffice.nav.package',
                    active: true,
                }
            ],
            permission: 'Packages',
        },
    },
    {
        path: '/package/wizard/',
        name: 'packageWizard',
        component: () => import('@/views/package/PackageWizard/PackageWizard.vue'),
        meta: {
            breadcrumb: [
                {
                    text: 'backoffice.nav.package',
                    to: { name: 'package' },
                },
                {
                    text: 'backoffice.package.createPackage',
                    active: true,
                }
            ],
            permission: 'Packages',
        },
    },
    {
        path: '/package/wizard/:id',
        name: 'packageWizardEdit',
        component: () => import('@/views/package/PackageWizard/PackageWizard.vue'),
        meta: {
            breadcrumb: [
                {
                    text: 'backoffice.nav.package',
                    to: { name: 'package' },
                },
                {
                    text: 'backoffice.common.detail',
                    active: true,
                }
            ],
            permission: 'Packages',
        },
    },
    {
        path: '/package/preview/:id',
        name: 'packagePreview',
        component: () => import('@/views/package/PackagePreview/PackagePreview.vue'),
        meta: {
            breadcrumb: [
                {
                    text: 'backoffice.nav.package',
                    to: { name: 'package' },
                },
                {
                    text: 'backoffice.package.packagePreview',
                    active: true,
                }
            ],
            permission: 'Packages',
        },
    }
];
